import type { BuyerCreditBalance } from "./properties";
import { formatMinorCurrency } from "./currencyFormat";

// Builds the "credit available" hint shown on the listing reserve flow, or null
// when there is nothing to show. The hint promises "applied at checkout", so it
// must only appear when redemption would actually fire: the backend redeems one
// single credit that fully covers the fee, so a summed balance below the fee —
// or split across credits none of which covers it — must stay silent. An unknown
// fee or a balance without maxAmount (older API) fails closed for the same
// reason. Pure so the visibility + formatting rules are unit tested without the
// page.
export function creditHintMessage(
  balance: BuyerCreditBalance | null | undefined,
  feeMinor: number | undefined
): string | null {
  if (!balance || balance.available !== true || !(balance.amount > 0)) {
    return null;
  }
  if (!Number.isFinite(feeMinor) || (feeMinor as number) <= 0) {
    return null;
  }
  if (!(balance.maxAmount >= (feeMinor as number))) {
    return null;
  }
  // Format the redeemable credit, not the summed balance: checkout applies ONE
  // covering credit, so a split £100+£50 balance must read as £100, never £150.
  const formatted = formatMinorCurrency(balance.maxAmount, balance.currency);
  return `You have ${formatted} in credit available — it will be applied at checkout.`;
}
